module.exports = __webpack_public_path__ + "img/realistic.9d139435.png";